import { ILiteRouterApiResponse } from "models/ILiteRouterApiResponse";
import EssentialData from "../../../private/classes/EssentialData.class";
import { INeighborhoodAsset } from "models/Assets/INeighborhoodAsset";
import { ICoreModels } from "../types/types";

export function getCoreModels(
  routerApiResponse: ILiteRouterApiResponse,
  essentialData: EssentialData
): ICoreModels {
  const subCategory = essentialData.getSubCategoryBySubCatId(
    routerApiResponse?.subCategoryId,
    true
  );
  const cpOptions = [];
  (routerApiResponse?.dynamicAttributes || []).forEach((dynamicAttribute) => {
    const cp = essentialData.getOptionById(
      subCategory,
      dynamicAttribute.option_id,
      cpOptions.length > 0 ? cpOptions[cpOptions.length - 1].id : null
    );
    cpOptions.push(cp);
  });

  return {
    category: essentialData.getMainCategoryById(routerApiResponse?.categoryId),
    subCategory,
    city: essentialData.getCityById(routerApiResponse?.cityId),
    neighborhood: essentialData.getNeighborhoodFromCitiesByNeighborhoodId(
      routerApiResponse?.neighborhoodId,
      true
    ) as INeighborhoodAsset,
    cpOptions: cpOptions.length > 0 ? cpOptions : null,
  };
}
